import type { Task } from '@/student/types';

/**
 * The student has taken this graded oral exam: the pinned booking is attended
 * (`completed`) or the task is marked done. Once taken, the task page drops the
 * question pool and the "Before your exam" checklist.
 *
 * `currentBooking` must come from `useEventTaskSlots`, which only returns a
 * completed booking while it is still the pinned registration; after a failed
 * attempt the student is offered new slots and the exam counts as not taken.
 */
export function isOralExamTaken(
  task: Pick<Task, 'submission'> | null | undefined,
  currentBooking: { status?: string | null } | null | undefined,
): boolean {
  return task?.submission?.state === 'marked_as_done' || currentBooking?.status === 'completed';
}
